import { NextSeo } from "next-seo";
import SmartLink from "../components-reusable/Common/SmartLink/SmartLink";
import ResetPasswordForm from "../components-reusable/Forms/AuthenticationForms/ResetPasswordForm/ResetPasswordForm";
import OnboardingLayout from "../components-reusable/Layouts/OnboardingLayout/OnboardingLayout";

export default function ResetPasswordPage() {
  return (
    <OnboardingLayout
      footer={
        <>
          <div className="mb-2">
            Already have an account?{" "}
            <SmartLink href="/login">Sign in</SmartLink>
          </div>
          <div>
            Don&lsquo;t have an account?{" "}
            <SmartLink href="/signup">Sign up</SmartLink>
          </div>
        </>
      }
    >
      <NextSeo title="Reset Password | Tap For Service" description="" />
      <ResetPasswordForm />
    </OnboardingLayout>
  );
}
